import React from 'react';
import withEnterpriseLayout from 'src/components/AppRoutes/Enterprise/withEnterpriseLayout';

import { EmployeeListPage } from 'src/components/enterprise/features/Employee/EmployeeListPage/EmployeeListPage';
import { EmployeeCreatePage } from 'src/components/enterprise/features/Employee/CreatePage/EmployeeCreatePage';
import { EmployeeEditPage } from 'src/components/enterprise/features/Employee/EditPage/EmployeeEditPage';
import { EmployeeDetailsPage } from 'src/components/enterprise/features/Employee/EmployeeDetailsPage/EmployeeDetailsPage';

const EmployeeListPageLayout = withEnterpriseLayout(EmployeeListPage);
const EmployeeCreatePageLayout = withEnterpriseLayout(EmployeeCreatePage);
const EmployeeEditPageLayout = withEnterpriseLayout(EmployeeEditPage);
const EmployeeDetailsPageLayout = withEnterpriseLayout(EmployeeDetailsPage);

export const EmployeeListRoute = (): JSX.Element => (
  <EmployeeListPageLayout pageTitle="Employees" />
);
export const EmployeeCreateRoute = (): JSX.Element => (
  <EmployeeCreatePageLayout pageTitle="Add New Employee" />
);

export const EmployeeEditRoute = (): JSX.Element => (
  <EmployeeEditPageLayout pageTitle="Edit Employee" />
);

export const EmployeeDetailsRoute = (): JSX.Element => (
  <EmployeeDetailsPageLayout pageTitle="Employee Details" />
);
